import * as contact from '~web/i18n/french/contact.fr.i18n.json';
import * as core from '~web/i18n/french/core.fr.i18n.json';
import * as customEvent from '~web/i18n/french/custom-event.fr.i18n.json';
import * as discover from '~web/i18n/french/discover.fr.i18n.json';
import * as error from '~web/i18n/french/error.fr.i18n.json';
import * as event from '~web/i18n/french/event.fr.i18n.json';
import * as form from '~web/i18n/french/form.fr.i18n.json';
import * as login from '~web/i18n/french/login.fr.i18n.json';
import * as menu from '~web/i18n/french/menu.fr.i18n.json';
import * as meta from '~web/i18n/french/meta.fr.i18n.json';
import * as myYoop from '~web/i18n/french/my-yoop.fr.i18n.json';
import * as profile from '~web/i18n/french/profile.fr.i18n.json';
import * as promoter from '~web/i18n/french/promoter.fr.i18n.json';
import * as seating from '~web/i18n/french/seating.fr.i18n.json';
import * as staticPages from '~web/i18n/french/static-pages.fr.i18n.json';
import * as streaming from '~web/i18n/french/streaming.fr.i18n.json';
import * as token from '~web/i18n/french/token.fr.i18n.json';
import * as transaction from '~web/i18n/french/transaction.fr.i18n.json';
import * as timezone from '~web/i18n/french/timezone.fr.i18n.json';

export const french = {
  ...core,
  ...contact,
  ...customEvent,
  ...discover,
  ...error,
  ...event,
  ...form,
  ...login,
  ...menu,
  ...meta,
  ...myYoop,
  ...profile,
  ...promoter,
  ...seating,
  ...staticPages,
  ...streaming,
  ...timezone,
  ...transaction,
  ...token,
};



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/i18n/french.ts